<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="80px"
  >
    <el-form-item
      label="转发策略"
      prop="strategyId"
    >
      <el-select
        style="width: 100%"
        v-model="form.strategyId"
        placeholder="选择策略"
        clearable
      >
        <el-option
          v-for="(item,index) in sourceTypeList"
          :key="index"
          :label="item.strategyName"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="文章类型"
      prop="contentType"
    >
      <el-radio
        v-model="form.contentType"
        :label="1"
      >文本</el-radio>
      <el-radio
        v-model="form.contentType"
        :label="2"
      >图片</el-radio>
      <el-radio
        v-model="form.contentType"
        :label="3"
      >图文</el-radio>
    </el-form-item>
    <el-form-item
      v-if="form.contentType ==1"
      label="文章内容"
      prop="contentText"
    >
      <el-input
        type="textarea"
        placeholder="请输入"
        v-model="form.contentText"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.contentType ==2"
      label="文章内容"
      prop="contentImg"
    >
      <el-input
        v-model="form.contentImg"
        placeholder="图片链接"
      >
        <ossUploader
          class="pointer"
          slot="append"
          @uploaded="form.contentImg=$event"
        >
        </ossUploader>
      </el-input>
    </el-form-item>
    <el-form-item
      v-if="form.contentType ==3"
      label="文章内容"
      prop="contentEdit"
    >
      <quill-editor
        ref="editor"
        :defaultValues="form.contentEdit"
        @catchData="catchData"
      ></quill-editor>
    </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
import quillEditor from "@/components/public/quillEditor";
import ossUploader from "@/components/public/ossUploader";
import { queryTypeList } from "@/api/wx/strategyActicle";
let origin = {
  strategyId: '',
  contentType: 1,
  contentText: '',
  contentImg: '',
  contentEdit: '',
}
export default {
  name: "statrgyArticleForm",
  components: {
    quillEditor,
    ossUploader,
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          id: ''
        };
      }
    }
  },
  data() {
    return {
      sourceTypeList: [],
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        strategyId: [
          { required:true, message: '请选择', trigger: 'blur' },
        ],
        contentType: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        contentText: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        contentImg: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        contentEdit: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
      },
    }
  },
  mixins: [formLabalPosition],
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          this.assigen(newValue);
        }
      },
      deep: true,
    }
  },

  created(){
    this.getTypeList();
  },
  methods: {
    getTypeList(){
      queryTypeList({
        page: 1,
        limit: 500,
        'sidx': 'id',
        'order':'desc',
      }).then((res) => {
        this.sourceTypeList = res.page.list;
      })
    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(data){
      // todo
      this.form.id = data.id;
      this.form.strategyId = data.strategyId;
      this.form.contentType = data.contentType;
      this.form.contentText = data.contentText;
      this.form.contentImg = data.contentImg;
      this.form.contentEdit = data.contentEdit;
      switch (data.contentType) {
        case 1:
          this.form.contentText = data.content;
          break;
        case 2:
          this.form.contentImg = data.content;
          break;
        case 3:
          this.form.contentEdit = data.content;
          break;
      }
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass');
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
    catchData(content){
      this.form.contentEdit = content;
    }
  },
}
</script>

<style scoped>

</style>
